import * as actions from "@p81-common/shell-core-js/dist/redux/networksGet";
import {
  // SOCKET_EVENT_DEPLOY_SUCCESS,
  SOCKET_EVENT_DESTROY_SUCCESS,
} from "../networksBeaconsGet/networksBeaconsGetActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.NETWORKS_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
    tenantId: null,
  }),

  [actions.NETWORKS_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
    tenantId: action.tenantId,
  }),

  [actions.NETWORKS_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
    tenantId: null,
  }),

  // [SOCKET_EVENT_DEPLOY_SUCCESS]: (state, action) => {
  //   if (action.data.networkBeacon.tenantId !== state.tenantId) {
  //     return state;
  //   }

  //   return {
  //     ...state,
  //     shouldUpdateNetworks: Date.now()
  //   };
  // },

  [SOCKET_EVENT_DESTROY_SUCCESS]: (state, action) => {
    if (action.data.networkBeacon.tenantId !== state.tenantId) {
      return state;
    }

    return {
      ...state,
      data: {
        ...state.data,
        networks: state.data.networks.filter(
          ({ id }) => id !== action.data.networkBeacon.network
        ),
      },
      // shouldUpdateNetworks: Date.now()
    };
  },

  [CURRENT_CHILD_ORGANIZATION_SET]: () => ({ ...initialState }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
  tenantId: null,
};

export default function networksGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
